import arSa from "@/assets/flags/ar-sa.svg";
import en from "@/assets/flags/en.svg";
import es from "@/assets/flags/es.svg";
import ja from "@/assets/flags/ja.svg";
import ko from "@/assets/flags/ko.svg";
import ms from "@/assets/flags/ms.svg";
import mn from "@/assets/flags/mn.svg";
import ru from "@/assets/flags/ru.svg";
import th from "@/assets/flags/th.svg";
import vi from "@/assets/flags/vi.svg";
import zh from "@/assets/flags/zh.svg";
import my from '@/assets/flags/my.svg';
import km from '@/assets/flags/km.svg';

export const flagIcons = {
	"ar-sa": arSa,
	en,
	es,
	ja,
	ko,
	ms,
	mn,
	ru,
	th,
	vi,
	"zh-cn": zh,
	my,
	km
};
